/**
 * Полноэкранный просмотр изображения.
 *
 * Сервис приложения.
 * Не зависит от Screen, Block и RenderEngine.
 */
export class ImageViewer {

    public open(
        src: string
    ): void {

        const overlay =
            document.createElement("div");

        overlay.className =
            "image-viewer-overlay";

        const container =
            document.createElement("div");

        container.className =
            "image-viewer-container";

        const img =
            document.createElement("img");

        img.src =
            src;

        img.className =
            "image-viewer-image";

        const closeBtn =
            document.createElement("button");

        closeBtn.className =
            "image-viewer-close";

        closeBtn.textContent =
            "✕";

        container.appendChild(img);
        container.appendChild(closeBtn);

        overlay.appendChild(container);

        const close = () => {

            document.removeEventListener(
                "keydown",
                handleKeyDown
            );

            overlay.remove();

        };

        const handleKeyDown =
            (e: KeyboardEvent) => {

                if (e.key === "Escape") {
                    close();
                }

            };

        overlay.addEventListener(
            "click",
            close
        );

        container.addEventListener(
            "click",
            (e) => {

                e.stopPropagation();

            }
        );

        closeBtn.addEventListener(
            "click",
            (e) => {

                e.stopPropagation();
                close();

            }
        );

        document.addEventListener(
            "keydown",
            handleKeyDown
        );

        document.body.appendChild(
            overlay
        );

    }

}